import "intl-tel-input/build/css/intlTelInput.css";
import "./src/sms.css";
import intlTelInput from "intl-tel-input";
$(function () {
  const input = document.querySelector("#phone");
  // initialize
  let iti = intlTelInput(input, {
    initialCountry: "kw",
    utilsScript:
      "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js",
    preferredCountries: ["kw", "sa", "bh", "qa", "ae", "om", "ye"],
    autoPlaceholder: "aggressive",
    hiddenInput: "phone_number",
    separateDialCode: true,
  });
  $(input).on("change paste keyup", checkInput);
  iti.promise.then(checkInput);
  function checkInput() {
    $(input).attr("style", "padding-left: 100px;");
    let isValid = iti.isValidNumber();
    $("#submitBtn").attr("disabled", !isValid);
  }
});
